import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api_deletePartyAccessory, api_getPartyAccessorys } from '../../../api/catering/partyAccessory'; // Adjusted import for PartyAccessory APIs
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Button from '../../../components/bootstrap/Button';

const Item = ({ item, removePartyAccessoryFromTable, index }: any) => {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const handleDeletePartyAccessory = async (partyAccessoryId: string) => {
		try {
			setLoading(true);
			const res = await api_deletePartyAccessory(partyAccessoryId);
			if (res.isSuccess) {
				removePartyAccessoryFromTable(partyAccessoryId);
			} else {
				console.error('Failed to delete event type:', res.message);
			}
		} catch (error) {
			console.error('Error deleting event type:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<tr key={index}>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.name}</div> {/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.description}</div> {/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.price.from}</div> {/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.price.to}</div> {/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<span
					onClick={() => navigate(`/edit/partyAccessory`, { state: item })} // Navigate to edit event type route
					style={{ margin: 10, cursor: 'pointer' }}>
					EDIT
				</span>
				<span
					onClick={() => handleDeletePartyAccessory(item._id)}
					style={{ margin: 10, cursor: 'pointer' }}>
					{loading ? 'Loading..' : 'DELETE'}
				</span>
			</td>
		</tr>
	);
};

const AllPartyAccessory = () => {
	const [partyAccessorys, setPartyAccessorys] = useState<any>([]); // State variable to hold event types
	const [loading, setLoading] = useState(false);
	const [pageNo, setPageNo] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const navigate = useNavigate();
	const tableBodyRef = useRef<HTMLTableSectionElement>(null);

	// Function to fetch event types
	const getPartyAccessorys = async (page_no?: number) => {
		const finalPageNo = page_no || pageNo;

		try {
			setLoading(true);
			const res = await api_getPartyAccessorys(); // Fetch event types from API

			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
				} else {
					if (page_no === 1) {
						setPartyAccessorys(res.data);
						setPageNo(2);
					} else {
						setPartyAccessorys([...partyAccessorys, ...res.data]);
						setPageNo(pageNo + 1);
					}
				}
			} else {
				console.error('Failed to fetch event types:', res.message);
			}
		} catch (error) {
			console.error('Error fetching event types:', error);
		} finally {
			setLoading(false);
		}
	};

	// Function to remove event type from table
	const removePartyAccessoryFromTable = (partyAccessoryId: string) => {
		setPartyAccessorys(partyAccessorys.filter((e: any) => e._id !== partyAccessoryId));
	};

	// Load more event types
	const onLoadMore = () => {
		if (hasMore) {
			getPartyAccessorys();
		}
	};

	// Handle filter reset
	const handleFilterReset = () => {
		setPartyAccessorys([]);
		setHasMore(true);
		getPartyAccessorys(1);
	};

	// Fetch event types on component mount
	useEffect(() => {
		getPartyAccessorys();
	}, []);

	// Add scroll event listener to table body
	useEffect(() => {
		tableBodyRef.current?.addEventListener('scroll', (e) => {
			console.log(e);
		});
	}, []);

	return (
		<PageWrapper title={'Food Catering'}>
			<Card stretch>
				<CardHeader borderSize={1}>
					<CardLabel icon='Alarm' iconColor='info'>
						<CardTitle>All Party Accesories</CardTitle>
					</CardLabel>
					<CardActions>
						<Button
							onClick={() => navigate('/add/partyAccessory')}
							icon='PersonAdd'
							color='primary'
							isLight={true}>
							New Party Catering
						</Button>
					</CardActions>
				</CardHeader>
				<CardBody isScrollable className='table-responsive'>
					<table className='table table-modern'>
						<thead>
							<tr>
								<th>Name</th>
								<th>Description</th>
								<th>Price - From</th>
								<th>Price - To</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{partyAccessorys?.map((item: any, index: any) => (
								<Item
									key={index}
									item={item}
									index={index}
									removePartyAccessoryFromTable={removePartyAccessoryFromTable}
								/>
							))}
						</tbody>
					</table>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							marginBottom: '20px',
						}}>
						{hasMore && (
							<button
								style={{
									border: 'none',
									padding: '10px',
									borderRadius: '10px',
									cursor: 'pointer',
								}}
								onClick={onLoadMore}>
								Load More...
							</button>
						)}
					</div>
				</CardBody>
			</Card>
		</PageWrapper>
	);
};

export default AllPartyAccessory;
